<template>
  <div class="pageHome">
    <div class="topbox">
      <div class="title ">中控台</div>
      <div class="flex rigtop">
        <div class="date">{{ timeObj.curentDate }} <span class="zhou">周{{ timeObj.currentWeek }} </span></div>
        <div class="time">{{ timeObj.currentTime }}</div>
      </div>
    </div>
    <!-- 内容 -->
    <div>
      <!-- 上边4个 -->
      <div class="flex-center">
        <div class="topone">
          <paiqian></paiqian>
        </div>
        <div class="topone">
          <fuwu></fuwu>
        </div>
        <div class="topone">
          <jiuye></jiuye>
        </div>
        <div class="topone">
          <yonggong></yonggong>
        </div>
      </div>
      <!-- 下边两个 -->
      <div class="flex-center">
        <div class="btmone">
          <renqun></renqun>
        </div>
        <div class="btmone">
          <qiye></qiye>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import paiqian from "@/components/topFour/paiqian.vue";
import fuwu from "@/components/topFour/fuwu.vue";
import jiuye from "@/components/topFour/jiuye.vue";
import yonggong from "@/components/topFour/yonggong.vue";
import renqun from "@/components/btmTwo/renqun.vue";
import qiye from "@/components/btmTwo/qiye.vue";
import vueSeamlessScroll from "vue-seamless-scroll";


export default {
  components: {
    vueSeamlessScroll,
    paiqian,
    fuwu,
    jiuye,
    yonggong,
    renqun,
    qiye
  },
  data() {
    return {

      timeObj: {
        currentTime: '',
        curentDate: '',
        currentWeek: '',
      }
    }
  },
  mounted() {
    this.timer = setInterval(this.getTime, 1000);
    // 获取数据
    // this.getShuju();
  },
  methods: {
    // 格式化时间为 时:分:秒
    getTime() {


      let data = new Date();
      let y = data.getFullYear();
      let m =
        data.getMonth() + 1 < 10 ?
          '0' + (data.getMonth() + 1) :
          data.getMonth() + 1;
      let d = data.getDate() < 10 ? '0' + data.getDate() : data.getDate();
      let w = data.getDay();
      switch (w) {
        case 1:
          w = '一';
          break;
        case 2:
          w = '二';
          break;
        case 3:
          w = '三';
          break;
        case 4:
          w = '四';
          break;
        case 5:
          w = '五';
          break;
        case 6:
          w = '六';
          break;
        case 7:
          w = '日';
          break;
      }
      let h = data.getHours() < 10 ? '0' + data.getHours() : data.getHours();
      let mi = data.getMinutes() < 10 ? '0' + data.getMinutes() : data.getMinutes();
      let s = data.getSeconds() < 10 ? '0' + data.getSeconds() : data.getSeconds();
      // 年月日 星期几 时分秒
      this.timeObj = {
        curentDate: `${y}-${m}-${d}`,
        currentTime: `${h}:${mi}:${s}`,
        currentWeek: w,
      };



    },
    // 补零函数（确保个位数显示为两位数，如 9 → 09）
    padZero(num) {
      return num < 10 ? `0${num}` : num
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },

};
</script>
<style lang="less" scoped>
.pageHome {
  width: 100%;
  height: 100vh;
  font-family: Source Han Sans CN, Source Han Sans CN;
  background: radial-gradient(87% 87% at 111% 50%, rgba(24, 43, 116, 0.87) 7%, #030C34 100%);

  .btmone {
    width: 50%;
    height: 50%;
    margin-right: 20px;

    &:first-child {
      margin-left: 20px;
    }
  }


  .topbox {
    width: 100%;
    height: 100px;
    padding-top: 10px;
    background: url("@/assets/topbg.png") no-repeat 0 0/ 100% 100%;
    position: relative;

    .rigtop {
      position: absolute;
      right: 20px;
      top: 14px;

    }

    .time {
      font-weight: bold;
      font-size: 22px;
      color: #FFFFFF;
    }

    .date {
      color: #BBD6EF;
      font-size: 16px;
      margin-right: 20px;

      .zhou {
        display: inline-block;
        margin-left: 10px;
      }
    }

    .title {
      text-align: center;
      font-weight: bold;
      font-size: 40px;
      color: #FFFFFF;
    }

  }
}
</style>
